
import { Order } from '@/entities/orders/models/Order'
import { saveOrder } from '@/entities/orders/thunks/saveOrder'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { planningInboxRowsAdapter } from '../adapters/planningInboxRowsAdapter'
import { getInboxRowFromOrder } from '../libs/getInboxRowFromOrder'

export const initialPlanningInboxTableState = planningInboxRowsAdapter.getInitialState()

export const planningInboxTableSlice = createSlice({
  name: 'planningInboxTable',
  initialState: initialPlanningInboxTableState,
  reducers: {
    upsertPlanningInboxRows: (state, action) => {
      planningInboxRowsAdapter.upsertMany(state, action.payload)
    },
    replacePlanningInboxRows: (state, action) => {
      planningInboxRowsAdapter.setAll(state, action.payload)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(saveOrder.fulfilled, (state, action: PayloadAction<Order | null>) => {
      if (action.payload) {
        const inboxRow = getInboxRowFromOrder(action.payload)

        planningInboxRowsAdapter.upsertOne(state, inboxRow)
      }
    })
  },
})

export const { upsertPlanningInboxRows, replacePlanningInboxRows } = planningInboxTableSlice.actions